export const buttonThemeDefinition = () => ({
    MuiButton: {
        defaultProps: {
            disableFocusRipple: true,
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
            },
        },
    },
});
//# sourceMappingURL=buttonThemeDefinition.js.map